// Ultra‑basic React landing page for Askal Technology — now with a tiny story
// Usage:
// 1) Save as src/App.jsx (Vite/CRA) or a Next.js page component.
// 2) Put your logo at src/assets/askal-logo.png (or update the path below).
// 3) Simple centered intro + a short Askal story. No services yet.

import { useState } from "react";
import logo from "./assets/askal-logo.png"; // update if your path is different

export default function App() {
  return (
    <main style={styles.page}>
      <div style={styles.wrap}>
        {/* Logo */}
        <img src={logo} alt="Askal Technology logo" style={styles.logo} />

        {/* Name & Tagline */}
        <h1 style={styles.title}>Askal Technology</h1>
        <p style={styles.tagline}>The tech that barks</p>

        {/* Story */}
        <Story />
      </div>

      <footer style={styles.footer}>
        © {new Date().getFullYear()} Askal Technology
      </footer>
    </main>
  );
}

function Story() {
  const [expanded, setExpanded] = useState(false);

  const intro =
    "Our community had weak internet. Videos froze. Online classes dropped. People were upset. " +
    "One day a friendly askal walked in. He likes to sit near routers and watch the little lights. " +
    "He took a slow walk through the streets and noticed where the WiFi felt strong and where it disappears.";

  const more =
    "The askal made a simple plan. " +
    "He placed access points on many corners. At the barangay hall. Near the court. Along the main road." +
    " Each wifi access point shared the same network name and password. People could move and stay connected. " +
    "Calls were clear. Happy moments were now quickly shared online. Vloggers were able to upload their contents faster. Families watched movies together. " +
    "The community felt close again. This is what Askal Technology do. We listen. We put what is needed in the right place. We keep your internet steady.";

  return (
    <section aria-labelledby="story-title" style={styles.storyCard}>
      <h2 id="story-title" style={styles.storyTitle}>
        The Askal Story
      </h2>
      <p style={styles.storyText}>{intro}</p>
      {expanded && <p style={{ ...styles.storyText, marginTop: 8 }}>{more}</p>}
      <button onClick={() => setExpanded((v) => !v)} style={styles.btn}>
        {expanded ? "Show less" : "Read more"}
      </button>
    </section>
  );
}

const styles = {
  page: {
    background: "#004aad", // matches the logo background blue
    minHeight: "100svh",
    margin: 0,
    display: "grid",
    placeItems: "center",
    color: "#fff",
    fontFamily:
      "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji'",
    textRendering: "optimizeLegibility",
  },
  wrap: { textAlign: "center", padding: 24, maxWidth: 860 },
  logo: {
    width: "min(340px, 42vw)",
    height: "auto",
    display: "block",
    marginInline: "auto",
  },
  title: {
    margin: "18px 0 4px",
    fontSize: "clamp(28px,6vw,44px)",
    fontWeight: 800,
    letterSpacing: "-0.02em",
  },
  tagline: { margin: 0, fontSize: "clamp(14px,2.6vw,18px)", opacity: 0.98 },
  storyCard: {
    marginTop: 20,
    marginBottom: 20,
    background: "rgba(255,255,255,0.12)",
    border: "1px solid rgba(255,255,255,0.25)",
    borderRadius: 16,
    padding: 20,
    textAlign: "left",
  },
  storyTitle: {
    margin: 0,
    fontSize: "clamp(18px,3.6vw,22px)",
    fontWeight: 800,
    letterSpacing: "-0.01em",
  },
  storyText: { margin: "10px 0 0 0", lineHeight: 1.6 },
  btn: {
    marginTop: 14,
    background: "#fff",
    color: "#004aad",
    fontWeight: 700,
    border: 0,
    borderRadius: 999,
    padding: "10px 14px",
    cursor: "pointer",
  },
  footer: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 10,
    textAlign: "center",
    fontSize: 12,
    opacity: 0.85,
    pointerEvents: "none",
  },
};
